






import {
  Vue,
  Component,
} from "@/shared/vuepack";

  @Component
  export default class PartnerSettings extends Vue {}
